/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import './violationforplazareviewlisting.css'
import Table from 'react-bootstrap/Table'
import { downloadReviewViolation, getGridDataForPendingForReviewListing, getAuditGridData, getPlazaTAT } from '../../../common/apiService'
import CommonDateRangePicker from '../../../common/daterangepicker'
// import { CSVLink } from "react-csv";
import CustomPagination from '../../../common/custom_pagination'
import Loader from 'react-loader-spinner';
import Moment from 'moment'
import SelectSearch, { fuzzySearch } from "react-select-search";
import { BsArrowDown, BsArrowUp, BsFileEarmarkText } from 'react-icons/bs'
import Selfassignpopupscreenui from '../dashboard/selfassignpopupscreenui'
import '../../../common/selectsearch.css'
import { exportToExcel } from '../../../service/utilService'
import AuditLogDetailPopup from '../../Contents/auditlogdetailpopup'
import { startDate, endDate } from '../../../service/utilService'
import DownloadBtn from '../../../common/DownloadBtn';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { getJsonData } from '../../../service/utilService';
import { toast } from 'react-toastify';
import { UserContext } from '../../../contexts/UserContext';

export default function ViolationForPlazaReviewListing({ match, globalviolationdata, setGlobalActiveViolation, globalactiveviolation }) {

    const userDetail = useContext(UserContext);
    const [downloaddata, setDownloaddata] = useState([]);
    const [gridList, setGridList] = useState([]);
    const [jsonData, setJsonData] = useState(getJsonData(userDetail));
    const [mappedAVC, setMappedAVC] = useState("");
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState("0");
    const [violationtype] = useState("Violation for plaza review");
    const [Show1, setShow1] = useState(false);
    const [loading, setLoading] = useState(false);
    const [vioStatus, setSetVioStatus] = useState('""');
    const [totalGridData, setTotalGridData] = useState(0);
    const [showAuditLogPopup, setShowAuditLogPopup] = useState(false);
    const [auditpopupgridList, setAuditPopupGridList] = useState([]);
    const [selectedrrnno, setSelectedRrnNo] = useState(0);
    const [finalGridList, setGridListFinal] = useState([]);
    const [loadingreport, setLoadingReport] = useState(false);
    const [assignStatus, setAssignbyStatus] = useState("");
    const [etaData, setETAData] = useState('""');
    const [etaArray, setEtaArray] = useState([]);
    const [plazaTAT, setPlazaTAT] = useState(0);
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";


    // let etadropdownData = [
    //     { name: '3 & Less', value: '3 & Less' },
    //     { name: '24-48', value: '24-48' },
    //     { name: '48 & more', value: '48 & more' }

    // ];

    let violationstatusData = [
        { name: 'All', value: '""' },
        { name: 'Wrong Image', value: 'Wrong Image' },
        { name: 'Image Not Clear', value: 'Image Not Clear' },
        { name: 'Image Not Found', value: 'Image Not Found' },
        { name: 'NPCI Class is Correct-System', value: 'NPCI Class is Correct-System' },
        { name: 'NPCI Class is correct', value: 'NPCI Class is correct' },
        // { name: 'Timestamp not matching', value: 'Timestamp not matching' }
        { name: 'Rejected by model', value: 'Rejected by model' }
    ];

    const [sortedby, setSortedBy] = useState('');
    const [orderby, setOrderBy] = useState('asc');

    const getTATData = () => {

            getPlazaTAT().then(res =>{

                            
                            if (res) {
                                setPlazaTAT(res.data);
                                
                            }

                        }).catch(err=>{
                            console.log("Get Plaza TAT API Error "+err);
                        })
        }

    useEffect(() => {
        if(plazaTAT!==null && plazaTAT !==""){

            griddata();
            clearConsole();
        }
        // eslint-disable-next-line
    }, [plazaTAT,jsonData, mappedAVC, globalactiveviolation, vioStatus])

    useEffect(() => {
        if (currentPage !== "0")
            pageChange();
        // eslint-disable-next-line
    }, [currentPage])

    useEffect(() => {
        if (sortedby !== "")
            pageChange();
        // eslint-disable-next-line
    }, [sortedby, orderby]);



    const getETAClass = (e, index) => {

        const timer = etaArray.length ? etaArray[index] : getCountDownTime(e.plazaMark, e.readerReadTime);
        let hr = timer;
        // if (timer) {
        //     hr = timer.split(":")[0];
        // }
        if (hr > 96) return "fifthday-eta";
        if (hr > 72) return "fourthday-eta";
        if (hr > 48) return "thirdday-eta";
        if (hr > 24) return "secondday-eta";
        if (hr > 12) return "first_secondhalfday-eta";
        else return "first_firsthalfday-eta";
    }

    const getETACountDown = (e, index) => {
        if (etaArray.length)
            return etaArray[index]
        else
            return getCountDownTime(e.plazaMark, e.readerReadTime)
    }

    const diff_hours = (dt2, dt1) =>
    {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60);

        return Math.abs(Math.round(diff));
     // return difference in minutes
    }

    const getCountDownTime = (plazatime, readerredtime) => {
        if (!plazatime) {
            return "Expired";
        }
        const tat = plazaTAT;

        const tatMins = tat * 60;
        const oneDay = 24 * 60 * 60 * 1000;
        let istTime = new Date();
        //let istTime = new Date(currentTime + 5.5 * 60 * 60 * 1000);
        
        //const numberPlaza = diff_hours(new Date(), new Date(plazatime) );
        const numberBank = diff_hours(istTime, new Date(readerredtime) );
        const MinValNum = (tatMins - numberBank)-330;
        
        if (MinValNum <= 0) {
            return "Expired";
        }
        var milliseconds = MinValNum;
        var dateCus = new Date();
        dateCus.setDate(dateCus.getDate() - MinValNum);

        const rrt = new Date(plazatime.replace(".000+0000", ""));
        const d1 = milliseconds;
        const d2 = new Date() - rrt;
        // if (d2 >= d1)
        //     return "Expired";
        const duration = milliseconds ;

        let seconds = Math.floor((duration / 1000) % 60),
            minutes = Math.floor((duration / (1000 * 60)) % 60),
            hours = Math.floor((duration / (1000 * 60 * 60)) % 24),
            day = Math.floor((duration / (1000 * 60 * 60 * 24)));
        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
        if(duration >= 120){

            return (duration/60).toFixed(0);
            }
        else {

            return duration >= 60 ?  "01:"+((duration-60).toString().padStart(2,0)) : "00:"+duration.toString().padStart(2,0);
        }
    }

    const getCountDownTimeOld = (plazatime, readerredtime) => {
            if (!plazatime) {
                return "Expired";
            }

            const oneDay = 24 * 60 * 60 * 1000;
            const numberPlaza = diff_hours(new Date(), new Date(plazatime) );
            const numberBank = diff_hours(new Date(), new Date(readerredtime) );
            const MinValNum = Math.min(5760 - numberBank, 2880 - numberPlaza) - 330;
            if (MinValNum <= 0) {
                return "Expired";
            }
            var milliseconds = MinValNum;
            var dateCus = new Date();
            dateCus.setDate(dateCus.getDate() - MinValNum);

            const rrt = new Date(plazatime.replace(".000+0000", ""));
            const d1 = milliseconds;
            const d2 = new Date() - rrt;
            // if (d2 >= d1)
            //     return "Expired";
            const duration = milliseconds ;

            let seconds = Math.floor((duration / 1000) % 60),
                minutes = Math.floor((duration / (1000 * 60)) % 60),
                hours = Math.floor((duration / (1000 * 60 * 60)) % 24),
                day = Math.floor((duration / (1000 * 60 * 60 * 24)));
            hours = (hours < 10) ? "0" + hours : hours;
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            seconds = (seconds < 10) ? "0" + seconds : seconds;

            if(duration >= 120)
                return (duration/60).toFixed(0);
            else {
                return duration >= 60 ?  "01:"+((duration-60).toString().padStart(2,0)) : "00:"+duration.toString().padStart(2,0);
            }
        }


    const downloadfile = async (status) => {
        const bodyJson = {
            mapped_avc: mappedAVC,
            ViolationStatus: vioStatus,
            plazaIds: Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds
            // adjType: "DA",
            // status: status
        }
        const { plazaIds, ...restJsonData } = jsonData; // Remove plazaIds from jsonData before adding it to headerJson
        const headerJson = {
            ViolationStatus: vioStatus,
            ...restJsonData
        }
        setLoadingReport(true);
        let { data } = await downloadReviewViolation(headerJson, bodyJson);

        data.forEach(element => {   
            if(element.WideRangeImageName?.indexOf("TOLL_BCKUP/") === 50) {
                element.WideRangeImageName = element.WideRangeImageName.substring(element.WideRangeImageName.indexOf("TOLL_BCKUP/") + 11);
            }  
            
            if(element.RearViewImageName?.indexOf("TOLL_BCKUP/") === 50){
                element.RearViewImageName = element.RearViewImageName.substring(element.RearViewImageName.indexOf("TOLL_BCKUP/") + 11);
            }

            if(element.WideRangeImageName?.indexOf("toll/") === 58) {
                element.WideRangeImageName = element.WideRangeImageName.substring(element.WideRangeImageName.indexOf("toll/") + 5);
            
            } 
            
            if(element.RearViewImageName?.indexOf("toll/") === 58) {
                element.RearViewImageName = element.RearViewImageName.substring(element.RearViewImageName.indexOf("toll/") + 5);
            }
        
        
            
        });

        if (data !== 'jsonArray')
        exportToCSV(data, "pending_review_violation");
        else
        toast.warning("No Data found");
        setLoadingReport(false);
    }

    const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(apiData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    const getJson = () => {
        const bodyJson = {
            mapped_avc: mappedAVC,
            plazaIds: Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds
            // adjType: "DA",
        }
        const { plazaIds, ...restJsonData } = jsonData; // Remove plazaIds from jsonData before adding it to headerJson
        const headerJson = {
            ViolationStatus: vioStatus,
            ...restJsonData

        }
        const paramJson = {
            offset: currentPage,
            limit: '50',
            sort_c: sortedby,
            sort_t: orderby
        }
        const json = {
            bodyJson: bodyJson,
            headerJson: headerJson,
            paramJson: paramJson
        }
        return json;
    }

    const griddata = async (val) => {
        setGridList([]);
        setTotalPage(0);
        setTotalGridData(0);
        setLoading(true);


        const { headerJson, bodyJson, paramJson } = getJson();
        // const ViolationStatus = (val && val.length > 0) ? val.reduce((a, v) => a + "," + v) : "";
        // headerJson.ViolationStatus = ViolationStatus;
        setAssignbyStatus(headerJson.ViolationStatus);
        try {
            getTATData();
            
            const res = await getGridDataForPendingForReviewListing(headerJson, bodyJson, paramJson);
            const data = res.data.data;

            if (data.length > 0) {
                let istTime = new Date();
                //let istTime = new Date(currentTime + 5.5 * 60 * 60 * 1000);

                
                const filteredGrid1 = data.filter(row => {

                    if (!row.plazaMark) {
                        return false
                    }
                    //const numberPlaza = diff_hours(new Date(), new Date(row.plazaMark) );
                    
                    const numberBank = diff_hours(istTime, new Date(row.readerReadTime) );
                    
                    const tat = parseInt(plazaTAT);

                    const tatMins = tat * 60;

                    const MinValNum = (tatMins - numberBank)-330;
                    
                    if (MinValNum <= 0) {
                        return false
                    }
                    return MinValNum;
                });
                const filteredGrid2 = data.filter(row => !filteredGrid1.includes(row))
                const sortdata = filteredGrid1.sort((a, b) => diff_hours(new Date(a.readerReadTime), new Date(b.readerReadTime) ));
                const finalGrid = [...sortdata, ...filteredGrid2];
                setGridList(finalGrid);
            } else {
                setGridList([]);
            }
            const totalpages = res.data.pages;
            setTotalPage(totalpages);
            setTotalGridData(res.data.totalElements);
            setLoading(false);
        } catch {
            setTotalPage(0);
            setTotalGridData(0);
            setLoading(false);
            setGridList([]);
        }
    }

    useEffect(() => {
        let interval;
        if (gridList.length > 0) {
            let etaArr = [];
            gridList.forEach(e => {
                const timer = getCountDownTime(e.plazaMark, e.readerReadTime);
                etaArr.push(timer);
            })
            setEtaArray(etaArr);
            interval = setInterval(() => {
                let etaArr = [];
                gridList.forEach(e => {
                    const timer = getCountDownTime(e.plazaMark, e.readerReadTime);
                    etaArr.push(timer);
                })
                setEtaArray(etaArr);
            }, 1000)
        }
        return () => {
            clearInterval(interval);
        }
    }, [gridList])
    
    const pageChange = () => {
        griddata();
    }

    const clearConsole = () => {
        setTimeout(() => {
            // console.clear();
        }, 800)
    }

    const gridShort = (val) => {
        if (val !== sortedby) {
            setSortedBy(val);
            setOrderBy('asc');
        } else {
            if (orderby === 'asc')
                setOrderBy('desc');
            else
                setOrderBy('asc')
        }
    }

    const arrow = (val) => {
        if (val === sortedby && orderby === 'asc')
            return (<BsArrowDown className="sort-arrow" />);
        else if (val === sortedby && orderby === 'desc')
            return (<BsArrowUp className="sort-arrow" />)
    }

    const getAuditPopupGridData = (row) => {
        const caseId = row.id;
        setSelectedRrnNo(row.rrn);
        setLoading(true);
        getAuditGridData(caseId).then(res => {
            setGridListFinal([]);
            res.data.forEach(function (item, index) {
                if (item.updatedColumns?.length > 0) {
                    item.updatedColumns.forEach(function (items, indexs) {
                        if (items === 'Remark' || items === 'AssignedUserID' || items === 'Maker_Attempt' || items === 'Checker_Attempt' || items === 'Case_Status_Description' || items === 'case_life' || items === 'plaza_date_mark' || items === 'bank_date_mark' || items === 'expired_dt') {
                            finalGridList.push({ "datetime": item.modifiedDate, "from": item.oldData[items], "to": item.newData[items], "colmname": items })
                        }
                    });
                }
            });

            setLoading(false);

            if (res.data && res.data !== "No record Found!")
                setAuditPopupGridList(finalGridList);
            else
                setAuditPopupGridList([]);
            setShowAuditLogPopup(true);
        }).catch(err => {
            setLoading(false);
            setAuditPopupGridList([]);
        })
    }

    return (
        <>
            <Selfassignpopupscreenui
                origin="assign"
                activeCount={totalGridData}
                updateActiveCount={setTotalGridData}
                show1={Show1}
                setShow1={setShow1}
                assignBy={assignStatus}
                jsonD={jsonData}
                griddata={griddata}
            />
            <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={100}
                width={100}
                visible={loading}
                style={{ backgroundColor: 'lightgrey' }} />

            <AuditLogDetailPopup
                setShowAuditLogPopup={setShowAuditLogPopup}
                showAuditLogPopup={showAuditLogPopup}
                gridList={auditpopupgridList}
                selectedrrnno={selectedrrnno}
            />

            <div className="container-fluid assignMakers">
                <div className="row">
                    <div className="col-md-5">
                        <h3>{violationtype} </h3>
                        {/* {JSON.parse(localStorage.getItem("userDetailsIDFC")).roles == 'checker' ? <span>for recheck</span> : null}  */}
                    </div>
                    <div className="col-md-4">
                    </div>
                    <div className="col-md-3">
                        <button className="assignedbtn" onClick={() => setShow1(true)}>Assign to me</button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="col-md-12">
                    <div className="row filterssrtip">
                        <div className="col-md-4">
                            <h4 className="lowh3">Pending violations for plaza review - <span>{totalGridData}</span>
                            </h4>
                        </div>
                        <div className="col-md-8 option">
                            <DownloadBtn
                                downloaddata={downloaddata}
                                loadingreport={loadingreport}
                                downloadexcel={downloadfile}
                            />
                            <CommonDateRangePicker
                                plazaClassName="tollfilter"
                                datepickerClassName="daterange"
                                setjsonData={setJsonData}
                            />
                            <div className="violationstatusfilter">
                                <SelectSearch
                                    options={violationstatusData}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="Violation Status"
                                    // multiple="true"
                                    value={vioStatus}
                                    onChange={(selectedValue) => setSetVioStatus(selectedValue)}
                                />
                            </div>
                            {/* <div className="etafilter" >
                                <SelectSearch style={{ width: 100 }}
                                    options={etadropdownData} 
                                    search
                                    filterOptions={fuzzySearch}
                                    value={etadropdownData.value}
                                    placeholder="ETA"
                                    onChange={(selectedValue) => setMappedAVC(selectedValue)}
                                />
                            </div> */}
                        </div>
                    </div>
                    <div style={{ maxHeight: 600, overflowX: 'hidden', width: '100%', marginBottom: 10 }}>
                        <Table striped bordered hover variant="light" className="customTable">
                            <thead>
                                <tr className="pointer" style={{ position: 'sticky', top: -1 }}>
                                    <th>RRN </th>
                                    <th>Tag ID </th>
                                    <th>Reader Read Time </th>
                                    <th>Mapped AVC </th>
                                    <th>NPCI VC </th>
                                    <th>Status Remarks </th>
                                    <th>ETA Hours </th>
                                    {/* <th onClick={() => gridShort('eta')}>ETA {arrow('eta')}</th> */}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {gridList.length > 0 ?
                                    gridList.map((e, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{e.rrn}</td>
                                                <td>{e.tagId}</td>
                                                <td>{Moment.utc(e.readerReadTime).format("yyyy.MM.DD, hh:mm:ss A")}</td>
                                                <td>{e.mappedAvc}</td>
                                                <td>{e.npciVehicleClass}</td>
                                                <td>{e.remark}</td>
                                                {/* <td><span className="etablock pink-eta">24 hours</span></td> */}
                                                <td className='eta_th_column'><span className={"etablock " + getETAClass(e, index)}>{getETACountDown(e, index)}</span></td>
                                                <td style={{ width: 60, cursor: 'auto', padding: '7px 15px' }} >
                                                    <div className="ripple"
                                                        onClick={() => getAuditPopupGridData(e)}>
                                                        <BsFileEarmarkText title="Log details" className="auditbtn edit" />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center' }}>Data Not Found!</td>
                                    </tr>
                                }


                            </tbody>
                        </Table>
                    </div>
                    <CustomPagination
                        currentPage={currentPage}
                        totalPage={totalPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
        </>
    )
}
